export default "<app-category-selector [parent]=\"parent\" (onSelect)=\"onSelect($event)\"></app-category-selector>"